import React from 'react';
import { Input } from './ui/input';
import { Search } from 'lucide-react';

export function SearchFilter({ value, onChange, placeholder = "Cari..." }) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}